import {useState} from "react";
import axios from "axios";

interface ApiCallProps {
    url: string;
    method?: 'post' | 'put' | 'delete';
}

export default function useApiCall<InputData extends Record<string, any>, ResponseData extends Record<string, any>>({ url, method = 'post' }: ApiCallProps) {
    const [isSubmitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const onSubmit = (data?: InputData) => {
        setError('');
        setSubmitting(true);
        return axios[method]<ResponseData>(url, data)
            .then((resp) => {
                const isSuccess = [201, 200, 204].includes(resp.status)
                if (!isSuccess) {
                    throw new Error(resp.data?.message || resp.statusText);
                }
                return resp.data?.data || isSuccess;
            })
            .catch((e) => {
                setError(e.response?.data?.message || e.message);
                return false;
            })
            .finally(() => setSubmitting(false))
    }

    const reset = () => {
        setError('');
        setSubmitting(false);
    }
    return {
        onSubmit,
        isSubmitting,
        error: error,
        reset,
    }
}
